import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CreateEventForm } from "@/components/CreateEventForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CreateEvent = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 pt-32 pb-12 flex flex-col items-center">
        <div className="w-full max-w-2xl">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="mb-6 text-white hover:text-gray-300"
          >
            <ArrowLeft className="h-6 w-6" />
          </Button>
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-3 bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent">
              Submit Your Event for Review
            </h2>
            <p className="text-gray-300 max-w-xl mx-auto">
              Fill out the details below to list your event. Our team will review your submission and approve it for public listing.
            </p>
          </div>
          <CreateEventForm />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CreateEvent;